import axios from 'axios'

export const getInfo = ({ commit }) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-info-singkat/")
            .then((response) => {
                commit('SET_INFOS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const storeInfo = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios.post("/api/store-info-singkat", payload).then(() => {
            let notif = {
                msg: "Info Singkat Berhasil ditambahkan~",
                type: "create"
            }
            dispatch("getInfo").then(() => {
                commit("SET_NOTIF", notif, { root: true });
            });
            resolve("ok")
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const updateInfo = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios.put("/api/update-info-singkat/"+ payload.id, payload).then(() => {
            let notif = {
                msg: "Info Singkat Berhasil diupdate~",
                type: "update"
            }
            dispatch("getInfo").then(() => {
                commit("SET_NOTIF", notif, { root: true });
            });
            resolve("ok")
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const deleteInfo = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-info-singkat/" + payload.id).then((response) => {
            let notif = {
                msg: "Info Singkat Berhasil dihapus~",
                type: "delete"
            }
            dispatch("getInfo").then(() => {
                commit("SET_NOTIF", notif, { root: true });
            });
            resolve("ok")
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject("fail")
        });
    })
}